module.exports = __webpack_public_path__ + "media/images/cbjj/logo-cbjj-white-aff330a40fd95a3e2b581eebab01d75d.png";